module["exports"] = [
  "###-####"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/ja/address/postcode.js
// module id = 1098
// module chunks = 0